import { useMutationBuilder, useQueryBuilder } from "../useBuilders";
import {  ACTION_NEEDED, ACTIVATION, CAPABILITIES, EMAIL_SIGNATURE, FETCH, KEYS, PASSWORD, UPDATE, USER } from "../queryKeys";
import { profileApi } from "src/services/settings/profile";


export const useUserFetch = () => {
  return useQueryBuilder([USER, FETCH], profileApi.fetchUser);
};

export const useUserUpdate = () => {
  return useMutationBuilder([USER, UPDATE], profileApi.updateUser, [USER, FETCH]);
}

export const usePasswordUpdate = () => {
  return useMutationBuilder([PASSWORD, UPDATE], profileApi.updatePassword);
}

export const useEmailSignatureUpdate = () => {
  return useMutationBuilder([EMAIL_SIGNATURE, UPDATE], profileApi.updateEmailSignature, [USER, FETCH]);
}

export const useCapabilitiesActionNeededFetch = () => {
  return useQueryBuilder([USER, ACTION_NEEDED ], profileApi.fetchCapabilitiesActionNeeded);
}

export const useActivatedKeysFetch = () => {
    return useQueryBuilder([USER, ACTIVATION, KEYS], profileApi.fetchActivatedKeys);
}

